export type Environment = "production" | "test" | "local";

export class UrlProvider {
    static get root() {
        return  window.location.origin;
    }

     static spotlightApiRoot() {
         if (this.environment === "local" || window.location.host.indexOf("ngrok") > -1) 
            return "https://localhost:5051/api";

        return `${window.location.origin}/puzzle/api`;
    }

    public static get environment() : Environment {
        
        const prefix = window.location.host.toLowerCase().split(".")[0].split(":")[0];
        
        switch (prefix) {
            case "localhost": return "local";
            case "test": return "test";
            default:
                return "production";
        }
        
    }
}